// extracted by mini-css-extract-plugin
export default {"autocompleteInput":"AutocompleteWithBubblesNoPlusSign_autocompleteInput__+S8ic"};